export const SHOW = 'ta/popup/SHOW'
export const HIDE = 'ta/popup/HIDE'
